export default __webpack_public_path__ + "static/media/plus-green.2e2c49eb.svg";